<template>
  <div>
    <el-container class="layout-container">
      <el-main>
        <router-view :key="$route.fullPath" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'LayoutWithoutMenu',
}
</script>

<style lang="scss" scoped>
.layout-container {
  position: relative;
  width: 100%;
  margin: auto;
  height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('@/static/images/service-icon/serviceBack.png');
  .el-main {
    padding: 0;
    overflow: hidden;
  }
}
</style>
